import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth";
import LandingPage from "../pages/LandingPage";

export default function Splash() {
  const { user, checking } = useAuth();
  const nav = useNavigate();
  const [ready, setReady] = useState(false);

  // Quick 1s entry effect for authenticated checks
  useEffect(() => {
    const t = setTimeout(() => setReady(true), 800);
    return () => clearTimeout(t);
  }, []);

  // Seamless redirection if the user is already authenticated
  useEffect(() => {
    if (!ready || checking) return;
    if (user) {
      nav("/home", { replace: true });
    }
  }, [ready, checking, user, nav]);

  // Loading state (while checking authentication credentials)
  if (checking || (ready && user)) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-[#0F172A] text-white">
        <div className="relative z-10 flex flex-col items-center animate-fadeIn">
          <div className="w-16 h-16 rounded-3xl flex items-center justify-center shadow-xl shadow-indigo-500/25 transform rotate-3 animate-pulse overflow-hidden">
            <img src="/logo192.png" alt="CarTrack Logo" className="w-full h-full object-cover" />
          </div>
          <h1 className="mt-6 text-3xl font-black tracking-tight text-white">CarTrack</h1>
          <p className="mt-2 text-slate-400 text-sm font-medium">Securing your journey...</p>
          <div className="mt-8 flex gap-1.5">
            <span className="w-2.5 h-2.5 rounded-full bg-indigo-600 animate-pulse" />
            <span className="w-2.5 h-2.5 rounded-full bg-indigo-600/60 animate-pulse [animation-delay:150ms]" />
            <span className="w-2.5 h-2.5 rounded-full bg-indigo-600/30 animate-pulse [animation-delay:300ms]" />
          </div>
        </div>
      </div>
    );
  }
  return <LandingPage />;
}
